const Footer = () => {
    return (
        <footer className="w-full text-center text-sm mb-4 px-4 opacity-60 h-10">
            <div className="sm:hidden">
                Learn more about the team{' '}
                <a
                    href="/faq#team"
                    className="underline decoration-1 decoration-dotted underline-offset-2"
                >
                    here
                </a>
            </div>
        </footer>
    )
}
export default Footer
